export interface AlainLodopConfig {
  /**
   * æ³¨åä¿¡æ¯ï¼ä¸»æ³¨åå·
   */
  license?: string;
  /**
   * æ³¨åä¿¡æ¯ï¼éå æ³¨åå·A
   */
  licenseA?: string;
  /**
   * æ³¨åä¿¡æ¯ï¼éå æ³¨åå·B
   */
  licenseB?: string;
  /**
   * æ³¨åä¿¡æ¯ï¼æ³¨ååä½åç§°
   */
  companyName?: string;
  /**
   * Lodop è¿ç¨èæ¬URLå°åï¼**æ³¨æ**å¡å¿ä½¿ç¨ `name` å±æ§æå®åéå¼
   *
   * - http://localhost:18000/CLodopfuncs.js
   * - https://localhost:8443/CLodopfuncs.js [é»è®¤]
   */
  url?: string;
  /**
   * Lodop åéåï¼é»è®¤ï¼`CLODOP`
   */
  name?: string;
  /**
   * æ£æ¥æ¬¡æ°ï¼é»è®¤ `100`ï¼å½æ£æ¥è¶è¿æ¶è§ä¸ºå¼å¸¸ï¼è¿æ¯å ä¸º Lodop éè¦è¿æ¥ WebSocket
   */
  checkMaxCount?: number;
}
